import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from '../components/ui5';

const AutoBreadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Define route configurations with titles
  const routeConfig = {
    '/dashboard': 'Dashboard',
    '/service-catalog': 'Service Catalog',
    '/service-usage': 'Service Usage',
    '/change-impact': 'Change Impact Analysis',
    '/whats-new': "What's New",
    '/generate-report': 'Generate Report',
  };

  // Define breadcrumb hierarchy
  const breadcrumbConfig = {
    '/dashboard': [],
    '/service-catalog': [{ path: '/dashboard', title: 'Dashboard' }],
    '/service-usage': [
      { path: '/dashboard', title: 'Dashboard' },
      { path: '/service-catalog', title: 'Service Catalog' },
    ],
    '/change-impact': [{ path: '/dashboard', title: 'Dashboard' }],
    '/whats-new': [{ path: '/dashboard', title: 'Dashboard' }],
    '/generate-report': [{ path: '/dashboard', title: 'Dashboard' }],
  };

  // Don't show breadcrumbs on dashboard (root page)
  if (pathname === '/' || pathname === '/dashboard') {
    return null;
  }

  const currentRoute = routeConfig[pathname];
  const breadcrumbPath = breadcrumbConfig[pathname] || [];

  if (!currentRoute) {
    return null;
  }

  return (
    <div className="px-6 py-3 bg-white border-b">
      <Breadcrumb>
        <BreadcrumbList>
          {breadcrumbPath.map((crumb, index) => (
            <React.Fragment key={crumb.path}>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={crumb.path}>{crumb.title}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
            </React.Fragment>
          ))}
          <BreadcrumbItem>
            <BreadcrumbPage>{currentRoute}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default AutoBreadcrumb;
